export enum ExternalFeatureCategories {
  Undefined = 0,
  MarketingAppsSettings = 1,
  AdvancedMarketingTools = 2,
  OutboundCampaigns = 3,
  ReportingAnalytics = 4,
  Contacts = 5,
  CustomTransactionReport = 6,
  LoyaltyReporting = 7
}

export enum ExternalFeatureTypes {
  Vouchers = 1,
  LoyaltyProgram = 2,
  Coupons = 3,
  Surveys = 4,
  TwoReward = 5,
  Waitlist = 6,
  SmsGlobal = 7,
  LoginGlobal = 8,
  Landing = 9,
  CodeGeneration = 10,
  EmailMarketing = 11,
  TabletKiosk = 12,
  ReplyReview = 13,
  SocialMediaMarketing = 14,
  OnlineListingsManagement = 15,
  UnifiedReportingDashboard = 16,
  ExecutiveReport = 17,
  AppsMarketplace = 18,
  Connectors = 19,
  CouponsCatalog = 20,
  MobileKiosk = 21,
  CampaignAutomation = 22,
  SingleUrl = 23,
  GoogleTagManager = 24,
  ReferralProgram = 25,
  BirthdayClub = 26,
  RedeemReferralsReport = 27,
  ReferralRewardsRedemptions = 28,
  smsContacts = 29,
  loyaltyContacts = 30,
  SmsReminder = 31,
  VipClub = 32,
  AppoinmentBooking = 33,
  LoyaltyUsers,
  CouponEdit,
  CreateCoupon,
  GamifiedCoupons,
  GoogleBusinessProfile,
  Facebook,
  GoogleAnalytics,
  GoogleSearchConsole,
  ShopifyStorefront,
  QuickbooksOnline,
  LoyaltyProgramRegisteredUsers,
  LinkToAny,
  FlowAutomation
}

export enum ExternalFeatureCode { // client enum
  Vouchers = "vouchersCard",
  LoyaltyProgram = "mobileloyality",
  DigitalCoupons = "digitalcoupons",
  Surveys = "customersurvey",
  TwoReward = "2reward",
  DigitalWaitlist = "digitalwaitlist",
  GlobalSms = "globalsms",
  GlobalLogin = "globallogin",
  LandingPages = "landingPages",
  CodeGeneration = "randomCodesGenerator",
  EmailMarketing = "emailMarketing",
  TabletKiosk = "tabletKiosk",
  ReplyReview = "replyReview",
  SocialMarketing = "socialMarketing",
  ListingsManagement = "listingsManagement",
  ReportingDashboard = "reportingDashboard",
  ExecutiveReport = "executiveReport",
  AppsMarketplace = "appsMarketplace",
  Connectors = "connectors",
  CouponsCatalog = "couponsCatalog",
  MobileKiosk = "mobileKiosk",
  CampaignAutomation = "campaignAutomation",
  SingleUrl = "singleUrl",
  GoogleTagManager = "googleTagManager",
  ReferralProgram = "referralProgram",
  BirthdayClub = "birthdayClub",
  RedeemReferralsReport = "redeemReferralsReport",
  ReferralRewardsRedemptions = "referralRewardsRedemptions",
  SmsContacts = "smsContacts",
  LoyaltyContacts = "loyaltyContacts",
  SmsReminders = "smsReminders",
  VipClub = "vipClub",
  AppointmentBooking = "appoinmentBooking",
  LoyaltyUsers = "loyaltyUsers",
  CouponEdit = "couponEdit",
  CreateCoupon = "couponCreate",
  LinkToAny = "linkToAny"
}

export enum ExternalFeatureDependency {
  None = "None",
  Platform = "Platform",
  Pos = "Pos",
  Widget = "Widget"
}
